import React from 'react'

/**
 * Recursively injects props into input elements within a React node tree.
 */
export const injectPropsIntoInput = (
  node: React.ReactNode,
  inputProps: Record<string, unknown>
): React.ReactNode => {
  // Handle arrays and fragments at the top level
  if (Array.isArray(node)) {
    return node.map((child: React.ReactNode) =>
      injectPropsIntoInput(child, inputProps)
    )
  }
  if (React.isValidElement(node)) {
    if (node.type === 'input') {
      // eslint-disable-next-line
      return React.cloneElement(node, { ...inputProps, ...node.props })
    }
    // eslint-disable-next-line
    if (node.props && node.props.children) {
      return React.cloneElement(node, {
        // @ts-ignore next
        // eslint-disable-next-line
        children: React.Children.map(node.props.children, child =>
          // eslint-disable-next-line
          injectPropsIntoInput(child, inputProps)
        ),
      })
    }
    return node
  }
  // Handle React fragments
  if (
    React.isValidElement(node) &&
    node.type === React.Fragment &&
    // @ts-ignore next
    node.props?.children
  ) {
    return React.cloneElement(
      node,
      {},
      // @ts-ignore next
      // eslint-disable-next-line
      React.Children.map(node.props.children, child =>
        injectPropsIntoInput(child, inputProps)
      )
    )
  }
  return node
}
